<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 32 32"
  >
    <g>
      <path
        fill="#fff"
        d="M13.7 0h5.48c7.566 0 13.7 6.134 13.7 13.7s-6.134 13.7-13.7 13.7h-5.48c-7.566 0-13.7-6.134-13.7-13.7s6.134-13.7 13.7-13.7z"
      ></path>
      <path
        fill="#fff"
        d="M25.504 31.728v-7.535l-10.008 2.893s10.008 2.66 10.008 4.642z"
      ></path>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>
